module.exports = __webpack_public_path__ + "img/contrato_termos_adesao.0861a49a.jpg";